import { useEffect, useState } from "react";
import { FeedbackColumns, columns } from "./columns";
import DataTableFeedback from "./data-table";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/redux/hooks";
import { getFeedbacks } from "@/redux/feedback/feedback.action";
import { columnsResolved } from "../resolverdFBTable/columns";
import { feedbackSelector } from "@/redux/feedback/feedback.selector";
import ImagesDialog from "../ImagesDialog";
import { CenteredLoader } from "@/components/ui/loading";

const FeedbackTableRecent = () => {
  const dispatch = useAppDispatch();
  const { feedbacks, loading } = useSelector(feedbackSelector).ui;
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(
    null,
  );
  const [selectedImages, setSelectedImages] = useState<string[] | null>(null);

  useEffect(() => {
    dispatch(getFeedbacks());
  }, [dispatch]);

  const notResolvedFeedbacks = feedbacks?.filter(
    (feedback) => !feedback.isResolved,
  );
  const resolvedFeedbacks = feedbacks?.filter(
    (feedback) => feedback.isResolved,
  );

  const onImageClick = (images: string[], index: number) => {
    setSelectedImageIndex(index);
    setSelectedImages(images);
  };

  const dataNotResolved =
    (notResolvedFeedbacks &&
      notResolvedFeedbacks.map((feedback) => ({
        id: feedback.id,
        type: feedback.type,
        message: feedback.message,
        date: feedback.date,
        images: feedback.images,
        user: feedback.user,
        isResolved: feedback.isResolved,
      }))) ||
    [];

  const dataResolved =
    (resolvedFeedbacks &&
      resolvedFeedbacks.map((feedback) => ({
        id: feedback.id,
        type: feedback.type,
        message: feedback.message,
        date: feedback.date,
        images: feedback.images,
        user: feedback.user,
        isResolved: feedback.isResolved,
      }))) ||
    [];

  return (
    <div className="container mx-auto pb-2 min-w-full">
      {loading ? (
        <CenteredLoader message="Cargando comentarios..." />
      ) : (
        <DataTableFeedback
          columns={columns(onImageClick)}
          columnsResolved={columnsResolved(onImageClick)}
          dataNotResolved={dataNotResolved as FeedbackColumns[]}
          dataResolved={dataResolved as FeedbackColumns[]}
        />
      )}
      {selectedImages && selectedImageIndex !== null && (
        <ImagesDialog
          images={selectedImages}
          selectedImage={selectedImageIndex}
          setSelectedImage={(idx) => {
            if (idx === null) {
              setSelectedImages(null);
              setSelectedImageIndex(null);
            } else {
              setSelectedImageIndex(idx);
            }
          }}
        />
      )}
    </div>
  );
};

export default FeedbackTableRecent;
